import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";

import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

const { blue, carbon } = colorsPalettes;

export const SettingsActionsContainer = styled(FlexRow)<{ zIndex?: number }>`
    align-items: center;
    justify-content: end;
    padding: 8px 16px;
    border-top: 1px solid ${carbon[100]};

    position: sticky;
    bottom: 0;
    left: 0;

    background-color: ${carbon[0]};
    z-index: ${({ zIndex = 3 }) => zIndex};
`;

export const ButtonGroupWrapper = styled(FlexRow)`
    gap: 8px;
`;
export const CancelBtnText = styled.div`
    ${setFontVariant("button", blue[400])}
`;
export const PrimaryBtnText = styled.div`
    ${setFontVariant("button", carbon[0])}
`;
